import ZonePointType from "../../../enums/robot/rooms/zone-point-type";
import IBaseZone, { IBaseZoneApi, mapApiPointsToPoints, mapPointsToApi } from "./base-zone";

interface RoomLimitZone extends IBaseZone {}

export default RoomLimitZone;

export interface RoomLimitZoneApi extends IBaseZoneApi {}

export const mapLimitZoneApiToLimitZone = (apiData: RoomLimitZoneApi) => ({
  ...apiData,
  points: mapApiPointsToPoints(apiData.points, ZonePointType.RoomLimitZonePoint),
});
  
export const mapPartialLimitZoneToApi = (limitZone: Partial<RoomLimitZone>) =>
  ({
    ...limitZone,
    points: limitZone.points != null ? mapPointsToApi(limitZone.points.map((p) => p.point)) : undefined,
  } as Partial<RoomLimitZoneApi>);
  
  // we need the non-partial update for Webapp
  export const mapLimitZoneToApi = (limitZone: RoomLimitZone) =>
  ({
    ...limitZone,
    points: mapPointsToApi(limitZone.points.map((p) => p.point)),
  } as RoomLimitZoneApi);

export const isRoomLimitZone = (payload: unknown): payload is RoomLimitZone => {
  return (
    payload != null &&
    typeof payload === "object" &&
    "id" in payload &&
    "room" in payload &&
    "points" in payload
  );
}
  
